import React, { PureComponent } from 'react'
import { Icon } from "@ss/mtd-react"
import { GlobalColorSearchTypeList } from "@/utils/constant/home"

export default class ColorSearch extends PureComponent {
    render() {
        const { selectColor, handleSelectColor } = this.props;
        return (
            <div className='color-search-wrap'>
                <div className='title'>色彩搜图</div>
                <ul className='color-select-wrap'>
                    {
                        GlobalColorSearchTypeList.map(item => {
                            if (item.name === '白色') {
                                return (
                                    <li
                                        key={item.color}
                                        className="color-item-wrap"
                                        onClick={() => handleSelectColor(item)}
                                    >
                                        <div className="color-item-inner white-wrap">
                                            <div style={{ background: `${item.color}` }}></div>
                                            {
                                                selectColor && selectColor.name === item.name && <div className='color-item-close-wrap' onClick={(e) => { e.stopPropagation(); handleSelectColor(null) }}><Icon type='closemini'></Icon></div>
                                            }
                                        </div>
                                    </li>
                                )
                            } else {
                                return (
                                    <li
                                        key={item.color}
                                        className="color-item-wrap"
                                        onClick={() => handleSelectColor(item)}
                                    >
                                        <div style={{ background: `${item.color}` }} className="color-item-inner">
                                            {
                                                selectColor && selectColor.name === item.name && <div className='color-item-close-wrap' onClick={(e) => { e.stopPropagation(); handleSelectColor(null) }}><Icon type='closemini'></Icon></div>
                                            }
                                        </div>
                                    </li>
                                )
                            }
                        })
                    }
                </ul>
            </div>
        )
    }
}
